<template>
  <div class="blank-wrap">
    <span class="blank-input"
          :class="{ inline: isInLine, disabled: isDisable}"
          v-if="!isDone"
          type="text"
          @focus="handleFocus"
          @keydown.enter.prevent
          @keyup.enter.prevent="pressUpEnter"
          @keydown.delete="pressDownBackSpace"
          @keyup.delete="pressUpBackSpace"
          @input="setValue"
          @compositionstart="typingStart"
          @compositionend="typingEnd"
          :contenteditable="!isDisable"
          spellcheck="false"
          oncontextmenu="return false"
          oncopy="return false"
          onpaste="return false"
          oncut="return false"
          ref="input"></span>
    <p class="blank-result diff"
       :class="{ error: !isRight, inline: isDiffInLine }"
       ref="blank-result"
       v-else>
      <span class="error" v-show="!isRight">&nbsp;{{ value || youAnswer }}&nbsp;</span>
      <span class="success" :class="{ bracketed: !isRight}">{{ answer }}</span>
    </p>
  </div>
</template>

<script>
import utils from '@/services/utils';

const MIN_WIDTH = 120;

export default {
  props: {
    index: {
      type: Number,
      require: true,
    },
    answer: {
      type: String,
      require: true,
    },
    youAnswer: {
      type: String,
      require: true,
    },
    isDone: {
      type: Boolean,
      default: false,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    isRight: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: '',
      isInLine: false,
      isDiffInLine: false,
      isTyping: false,
      isPressing: false,
      backspacePressNumber: 0,
    };
  },
  watch: {
    isDone() {
      if (this.isDone) {
        this.$nextTick(() => {
          const pWidth = this.$refs['blank-result'].clientWidth;
          this.isDiffInLine = pWidth > MIN_WIDTH;
          this.reset();
        });
      }
    },
    isActive() {
      if (this.isActive) {
        this.$nextTick(() => {
          this.focus();
        });
      }
    },
    value() {
      this.updateInputInline();
    },
  },
  methods: {
    focus() {
      const el = this.$refs.input;
      if (el) {
        el.focus();
        if (typeof window.getSelection !== 'undefined'
          && typeof document.createRange !== 'undefined') {
          const range = document.createRange();
          range.selectNodeContents(el);
          range.collapse(false);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } else if (typeof document.body.createTextRange !== 'undefined') {
          const textRange = document.body.createTextRange();
          textRange.moveToElementText(el);
          textRange.collapse(false);
          textRange.select();
        }
      }
    },
    reset() {
      this.isInLine = false;
    },
    handleFocus() {
      this.$emit('focus', this.index);
    },
    pressUpBackSpace() {
      if (!this.value) {
        this.backspacePressNumber += 1;
        if (this.backspacePressNumber >= 2) {
          this.backspacePressNumber = 0;
          this.$emit('delete');
        }
      }
    },
    pressDownBackSpace() {
      this.updateInputInline();
    },
    pressUpEnter(event) {
      this.setValue(event);
      this.$emit('enter');
    },
    typingStart() {
      this.isTyping = true;
    },
    typingEnd() {
      this.isTyping = false;
    },
    setValue(event) {
      this.value = utils.toCDB(event.target.innerText.replace(/\s+/g, ''));
      this.$emit('input', this.value);
    },
    updateInputInline() {
      if (this.$refs.input) {
        const spanWidth = this.$refs.input.clientWidth || this.$refs.input.offsetWidth;
        this.isInLine = spanWidth > MIN_WIDTH;
      } else {
        this.isInLine = false;
      }
    },
    syncValue() {
      /* eslint-disable no-lonely-if */
      if (this.isDone) {
        if (this.youAnswer) {
          this.value = this.youAnswer;
        }
      } else {
        if (this.youAnswer && this.$refs.input) {
          this.$refs.input.innerText = this.youAnswer;
          this.value = this.youAnswer;
        }
      }
    },
  },
  activated() {
    if (this.isActive) {
      this.focus();
    }
  },
  mounted() {
    if (this.isActive) {
      this.focus();
    }
    this.syncValue();
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .blank-wrap {
    display: inline;
    .blank-input, .blank-result {
      display: inline-block;
      min-width: 120px;
      line-height: 1;
      padding-bottom: 5px;
      border: 0;
      margin: 0;
      text-align: center;
      border-bottom: 2px solid $primary;
      color: $primary;
      // .bracketed {
      //   &:after {
      //     content: '）';
      //   }
      //   &:before {
      //     content: '（';
      //   }
      // }
      .error {
        text-decoration: line-through;
        margin-right: 10px;
        color: $danger;;
      }
      .success {
        color: $primary;
      }
      &.diff {
        border-bottom: 2px solid $success;
      }
      &:focus {
        outline: none;
      }
      &.error {
        color: $danger;;
        border-bottom: 2px solid $danger;
      }
      &.inline {
        display: inline;
      }
    }
    .disabled {
      vertical-align: middle;
    }
  }
</style>
